import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Gift, CheckCircle2, ChevronDown } from 'lucide-react';
export const Bonuses = () => {
  const mainBonuses = [{
    title: 'PREPARACIÓN FÍSICA ESPECÍFICA PARA CADA POSICIÓN',
    image: 'https://cdn.magicpatterns.com/uploads/jyJNd6QD99szGqWhfc3FPW/image.png',
    includes: ['Wings y Fullbacks', 'Aperturas y Medioscrum', 'Centros', 'Segundas Líneas', 'Hookers', 'Pilares'],
    routines: ['Fuerza', 'Potencia', 'Velocidad', 'Resistencia', 'Movilidad', 'Recuperación']
  }, {
    title: 'ALIMENTACIÓN Y PSICOLOGÍA DEPORTIVA PARA RUGBY',
    image: 'https://cdn.magicpatterns.com/uploads/7MnBXYyonLrX52N9ApDMAA/image.png',
    includes: ['Nutrición para rendimiento', 'Hidratación', 'Recuperación post partido', 'Alimentación pre competencia', 'Suplementación basada en evidencia', 'Psicología competitiva', 'Control emocional', 'Confianza deportiva', 'Concentración', 'Mentalidad ganadora']
  }, {
    title: 'MANUAL DE PREVENCIÓN DE LESIONES EN RUGBY',
    image: 'https://cdn.magicpatterns.com/uploads/gzjZekeuwreYfu4VutumZH/image.png',
    includes: ['Lesiones de hombro', 'Lesiones de rodilla', 'Lesiones de tobillo', 'Lesiones cervicales', 'Movilidad específica', 'Activación pre entrenamiento', 'Recuperación post partido', 'Protocolos preventivos', 'Fortalecimiento correctivo', 'Retorno seguro al entrenamiento']
  }, {
    title: 'DRILLS DE VELOCIDAD PARA RUGBY',
    image: 'https://cdn.magicpatterns.com/uploads/6NDPZ3P6rE94bhhmbz9WVS/image.png',
    includes: ['Drills de aceleración', 'Drills de reacción', 'Velocidad aplicada al juego', 'Cambios de dirección', 'Agilidad específica', 'Velocidad con toma de decisiones', 'Circuitos de velocidad', 'Salidas explosivas', 'Coordinación deportiva', 'Sprint progresivo']
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="w-full py-14 px-4 bg-zinc-900 border-t border-zinc-800" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <div className="text-center mb-10" data-id="element-13">
          <div className="inline-flex items-center justify-center gap-2 bg-lime-500/10 text-lime-400 px-3 py-1 rounded-full font-bold text-xs mb-4 border border-lime-500/20" data-id="element-14">
            <Gift className="w-3.5 h-3.5" data-id="element-15" />
            <span data-id="element-16">OFERTA ESPECIAL</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-bold uppercase tracking-tight mb-3 font-oswald text-white" data-id="element-17">
            4 BONOS ESTRATÉGICOS <span className="text-lime-400" data-id="element-18">GRATIS</span>{' '}
            POR HOY
          </h2>
          <p className="text-base text-zinc-400 max-w-2xl mx-auto" data-id="element-19">
            Llevate el sistema completo hoy y accedé a estos 4 complementos sin
            costo adicional.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-5" data-id="element-20">
          {mainBonuses.map((bono, idx) => {
          const isOpen = openIndex === idx;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.08
          }} className={`bg-zinc-950 rounded-xl border overflow-hidden flex flex-col transition-colors ${isOpen ? 'border-lime-500/60' : 'border-zinc-800 hover:border-lime-500/30'}`} data-id="element-21">
                <div className="relative h-40 w-full overflow-hidden" data-id="element-22">
                  <img src={bono.image} alt={bono.title} className="w-full h-full object-cover object-top" data-id="element-23" />
                  <div className="absolute inset-0 bg-gradient-to-t from-zinc-950 via-zinc-950/70 to-transparent" data-id="element-24"></div>

                  <div className="absolute bottom-0 left-0 w-full p-4" data-id="element-25">
                    <div className="text-lime-400 font-bold text-xs mb-1 font-oswald tracking-wider" data-id="element-26">
                      BONO {idx + 1}
                    </div>
                    <h3 className="text-base md:text-lg font-bold font-oswald uppercase leading-tight text-white" data-id="element-27">
                      {bono.title}
                    </h3>
                  </div>
                </div>

                <button type="button" onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-4 py-3 flex items-center justify-between text-left hover:bg-zinc-900/40 transition-colors" data-id="element-28">
                  <span className="text-sm font-semibold text-zinc-300" data-id="element-29">
                    {isOpen ? 'Ocultar contenido' : 'Ver qué incluye'}
                  </span>
                  <ChevronDown className={`w-5 h-5 transition-transform duration-300 ${isOpen ? 'rotate-180 text-lime-400' : 'text-zinc-500'}`} data-id="element-30" />
                </button>

                <AnimatePresence data-id="element-31">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.25
              }} className="overflow-hidden" data-id="element-32">
                      <div className="px-4 pb-4 space-y-3 border-t border-zinc-800 pt-3" data-id="element-33">
                        <div data-id="element-34">
                          <h4 className="text-zinc-500 text-[11px] font-bold uppercase tracking-wider mb-2" data-id="element-35">
                            Incluye:
                          </h4>
                          <ul className="grid grid-cols-2 gap-x-3 gap-y-1" data-id="element-36">
                            {bono.includes.map((item, i) => <li key={i} className="flex items-start gap-1.5 text-xs text-zinc-300" data-id="element-37">
                                <CheckCircle2 className="w-3 h-3 text-lime-500 shrink-0 mt-0.5" data-id="element-38" />
                                <span className="leading-tight" data-id="element-39">{item}</span>
                              </li>)}
                          </ul>
                        </div>

                        {bono.routines && <div data-id="element-40">
                            <h4 className="text-zinc-500 text-[11px] font-bold uppercase tracking-wider mb-2" data-id="element-41">
                              Rutinas específicas de:
                            </h4>
                            <div className="flex flex-wrap gap-1.5" data-id="element-42">
                              {bono.routines.map((routine, i) => <span key={i} className="bg-zinc-900 border border-zinc-800 text-[11px] text-zinc-300 px-2 py-0.5 rounded" data-id="element-43">
                                  {routine}
                                </span>)}
                            </div>
                          </div>}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
};